import React, { useState } from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { retreivePaymentRequestCode, retreivePaymentRequestCodeResponse } from "./TransactionRequestData/RetreivePaymentRequestCode";

const languageMap = {
    curl: 'bash',
    java: 'java',
    "C#": 'csharp',
    python: 'python',
    JavaScript: 'javascript'
};

const RetreivePaymentRequestComponent = () => {
    const [selectedLanguageRetreivePaymentRequest, setSelectedLanguageRetreivePaymentRequest] = useState('curl');
    const [copyStatus, setCopyStatus] = useState({ type: '', isCopied: false });

    const handleSelectedCode = (language) => {
        setSelectedLanguageRetreivePaymentRequest(language);
    };

    const handleCopyClick = (type) => {
        const textToCopy = type === 'retreivePaymentRequest' ? retreivePaymentRequestCode[selectedLanguageRetreivePaymentRequest].request : retreivePaymentRequestCodeResponse;
        navigator.clipboard.writeText(textToCopy)
        .then(() => {
            setCopyStatus({ type, isCopied: true });
            setTimeout(() => {
                setCopyStatus({ type: '', isCopied: false });
            }, 1000);
        })
        .catch((error) => {
            console.error('Error copying text: ', error);
            alert('Failed to copy text. Please try again.');
        });
};


    return (
        <section className="docs-section" id="retreive-payment-request">

                <div className="row flexbox">

                    <div className="col-md-5">
                        <h2 className="section-heading">Retreive Payment Request</h2>
                        <p><span className="badge badge-secondary back-blue">GET</span><span className="api"> /in-store/api/v1/transaction/{`{`}OnlineAPIRefId{`}`}/status</span></p>
                        <p>Service to get transaction status by OnlineAPIRefId</p>

                        <h4>Parameters</h4>

                        <div className="property-tab col-md-10 border-bottom">
                            <p required><span className="badge badge-secondary name">OnlineAPIRefId</span> &nbsp; &nbsp; <b>string</b></p>
                            <p className="description">OnlineAPIRefId which was received in the response of the purchase/refund or reversal request</p>
                        </div>

                        <br />

                        <div className="response-codes">

                            <h4>Response Codes</h4>

                            <div className="table-wrapper">

                                <h6 className="header">HTTP Status code summary</h6>

                                <table>
                                    <tbody>
                                        <tr>
                                            <td>200 Success</td>
                                            <td>Transaction status request is successfully processed</td>
                                        </tr>
                                        <tr>
                                            <td>400 Bad Request</td>
                                            <td>Bad request format or validation failed for incorrect data formats</td>
                                        </tr>
                                        <tr>
                                            <td>401 Unauthorized</td>
                                            <td>Request requires authentication, and the provided credentials are either missing, invalid, or insufficient, hence send a valid merchant access token (Bearer) issued by Westpay in the "Authorization" header</td>
                                        </tr>
                                        <tr>
                                            <td>409 Conflict</td>
                                            <td>A database operation may have caused a conflict</td>
                                        </tr>
                                        <tr>
                                            <td>422 Client Error</td>
                                            <td>Un-processable request. Most probably this happens when the specified OnlineAPIRefId is not found</td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>

                        </div>
                    </div>

            <div className="col-md-7 code-segments">
                    <div className="docs-code-block">
                    <pre tabIndex="-1" className="shadow-lg rounded">
                            <code className="language-dockerfile hljs">
                                <div className="row code-header">
                                    <div className="col-md-10 languages">
                                        <span>Request</span>
                                        {Object.keys(retreivePaymentRequestCode).map(language => (
                                            <React.Fragment key={language}>
                                                <input type="radio" name="langRetreivePaymentRequest" id={`${language}RetreivePaymentRequest`} onClick={() => handleSelectedCode(language)} checked={selectedLanguageRetreivePaymentRequest === language} />
                                                <label htmlFor={`${language}RetreivePaymentRequest`} className="language">{language}</label>
                                            </React.Fragment>
                                        ))}
                                    </div>
                                    <div className="col-md-2">
                                        {copyStatus.type !== 'retreivePaymentRequest' && <span className="copy-btn" title="Copy" onClick={() => handleCopyClick("retreivePaymentRequest")}><i className="fa fa-copy"></i></span>}
                                        {copyStatus.type === 'retreivePaymentRequest' && copyStatus.isCopied && <div className="copy-message">Copied &#x2713;</div>}
                                    </div>
                                </div>
                                <div className="code-section">
                                    <SyntaxHighlighter language={languageMap[selectedLanguageRetreivePaymentRequest]} style={dracula} showLineNumbers>
                                        {retreivePaymentRequestCode[selectedLanguageRetreivePaymentRequest].request}
                                    </SyntaxHighlighter>
                                </div>
                            </code>
                        </pre>
                    </div>
                    <div className="docs-code-block">
                    <pre tabIndex="-1" className="shadow-lg rounded">
                            <code className="language-dockerfile hljs">
                                <div className="row code-header">
                                    <div className="col-md-10 languages">
                                        <span>Response</span>
                                    </div>
                                    <div className="col-md-2">
                                        {copyStatus.type !== 'retreivePaymentRequestResponse' && <span className="copy-btn" title="Copy" onClick={() => handleCopyClick("retreivePaymentRequestResponse")}><i className="fa fa-copy"></i></span>}
                                        {copyStatus.type === 'retreivePaymentRequestResponse' && copyStatus.isCopied && <div className="copy-message">Copied &#x2713;</div>}
                                    </div>
                                </div>
                                <div className="code-section">
                                    <SyntaxHighlighter language="json" style={dracula} showLineNumbers>
                                        {retreivePaymentRequestCodeResponse}
                                    </SyntaxHighlighter>
                                </div>
                            </code>
                        </pre>
                    </div>
                </div>

        </div>

    </section>
    );
};


export default RetreivePaymentRequestComponent;
